<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item label="套装状态">
                <el-select v-model="formInline.status" clearable  placeholder="套装状态">
                    <el-option label="全部" value="9"></el-option>
                    <el-option label="启用" value="1"></el-option>
                    <el-option label="禁用" value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="套装名称">
                <el-input v-model="formInline.groupName" placeholder="套装名称"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="getList">查询</el-button>
                <el-button type="success" @click="handleEdit({groupId:0})">新增</el-button>
                <el-button type="success" @click="handleSync()">全部同步到BD</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="groupList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" >
            <!--  <el-table-column type="selection" width="55"></el-table-column>-->
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column label="套装图片">
                <template  slot-scope="scope">
                    <img :src="scope.row.listTemplateFile" width="120" height="80" class="head_pic"/>
                </template>
            </el-table-column>
            <el-table-column prop="groupName" label="套装名称"></el-table-column>
            <el-table-column prop="salePrice" label="套装价格"></el-table-column>
            <el-table-column prop="detailTemplateFile" label="包含单品总数"></el-table-column>
            <el-table-column label="操作" fixed="right" width="250">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="primary" size="mini" @click="handleEdit(scope.row)">修改</el-button>
                        <el-button type="success" size="mini" @click="handlePic(scope.row)">上传图片</el-button>
                        <el-button type="warning" size="mini" @click="handleGroupProduct(scope.row)">选择单品</el-button>
                    </el-button-group>

                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalRecord">
            </el-pagination>
        </div>

        <el-dialog  title="套装配置单品" :visible.sync="dialogFormVisible1" center>
            <el-form :model="form1" :inline="true" class="dialog-form-wrap">
                <el-form-item label="商品" >
                    <el-select v-model="form1.proId" clearable filterable  placeholder="选择商品">
                        <el-option
                                v-for="item in productList"
                                :key="item.proId"
                                :label="item.proName"
                                :value="item.proId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品数量" >
                    <el-input v-model="form1.proCount" placeholder="商品数量"></el-input>
                </el-form-item>
                <el-form-item label="商品单价" >
                    <el-input v-model="form1.proPrice" placeholder="商品单价"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" @click="addGroupProduct(form1)">添加单品</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="groupProductList" stripe border center :size="GCONFIG.styleTableSize">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="proName" label="商品名称"></el-table-column>
                <el-table-column prop="proCount" label="商品数量"></el-table-column>
                <el-table-column prop="proPrice" label="商品单价"></el-table-column>
                <el-table-column label="操作" fixed="right" width="160">
                    <template slot-scope="scope">
                        <el-button type="danger" size="mini" @click="handleDeleteGroupProduct(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getGroupList,delGroup,addGroup,getGroupProduct,getGroupProductList,addGroupProduct,getProducts,delGroupProduct,syncGroupsToBD} from '../../api/api'
    import selectPicComponents from '@/components/selectPic';

    //定义组件
    export default{
        data(){
            return {
                productList:[],
                groupProductList:[],
                loading:true,
                selectValue: '',
                dialogFormVisible1:false,
                form1:{
                    "groupId" : '',
                    "proId":"",
                    "groupName":"",
                    "proName":"",
                    "proCount":"",
                    "proPrice":""
                },
                formInline:{
                    "status":"",
                    "groupName":this.$route.query.groupName||"",
                    currentPage:parseInt(this.$route.params.id)||1,
                    recordsTotal:0,
                    pageSize:10,
                },
                formInline1:{
                    groupId:"",
                    groupName:""
                }
            }
        },
        computed:{
            groupList:function () {
                return this.$store.getters.getGroup.list
            },
            totalRecord:function () {
                return this.$store.getters.getGroup.total
            },
        },
        components:{
            selectPicComponents
        },
        //挂载时候执行
        mounted(){
            //获取套装添加单品下拉列表
            getProducts({}).then((res) => {
                console.log(res);
                this.productList = res.data.value;
            })
            //初始化首页数据
            this.getList();
        },
        methods:{
            //定义查询方法
            getList(){
                this.loading = true;
                let _this = this;
                this.$store.dispatch('initGroupList',this.formInline).then(function (res) {
                    _this.loading = false;
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.$router.push({path:'/grouplist/:id',name:'GroupList',params:{id:val}});
                this.getList();
            },
            handleEdit(row){
                this.$router.push({path:'/grouplist/detail/:id',name: 'GroupDetail',params:{id:row.groupId}})
            },
            handleSync(){
                syncGroupsToBD().then((res) => {
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleDel(row){
                this.$confirm('删除套装, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delGroup({groupId:row.groupId}).then((res) => {
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList(this.currentPage,this.pageSize);
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {

                });
            },
            handleGroupProduct(row){
                this.dialogFormVisible1=true;
                this.formInline1.groupId = row.groupId;
                this.formInline1.groupName = row.groupName;
                this.form1.groupId = row.groupId;
                this.form1.groupName = row.groupName;
                this.getGroupProductList();
            },
            getGroupProduct(){
                getGroupProduct(this.formInline1).then((res) => {
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.groupProductList = res.data.value;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            getGroupProductList(){
                getGroupProductList(this.formInline1).then((res) => {
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.groupProductList = res.data.value;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            addGroupProduct(form1){
                addGroupProduct(form1).then((res) => {
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.form1.proId = '';
                        this.form1.proCount = '';
                        this.form1.proPrice = '';
                        this.getGroupProduct();
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleDeleteGroupProduct(row){
                this.$confirm('删除该商品, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delGroupProduct({groupId:row.groupId,proId:row.proId}).then((res) => {
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getGroupProduct(this.currentPage,this.pageSize);
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {

                });
            },
            handlePic(row){
                let routerL = '/'+this.$route.path.split('/')[1];
                this.$router.push({path:routerL+'/picture/'+row.groupId,query:{picType:'5',picName:row.groupName,picState:'group'}})
            }
        }
    }
</script>
<style scoped>
    .dialog-form-wrap{
        border-bottom: 1px solid #eeeeee;
        margin-bottom: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/views/sales/groupList.vue